import "./FormStyles.css"

import React from 'react'

const Form = () => {
  return (
    <div className="form">

      <form name="contact-form-2026" method="POST" data-netlify="true"
        data-netlify-honeypot="bot-field">
        {/* Hidden field for Netlify */}
        <input type="hidden" name="form-name" value="contact-form-2026" />

        <p hidden>
          <label>
            Don’t fill this out: <input name="bot-field" />
          </label>
        </p>

        <label for="name">Your Name</label>
        <input type="text" name="name" id="name" required />

        <label for="email">Email</label>
        <input type="email" name="email" id="email" required />

        <label for="subject">Subject</label>
        <input type="text" name="subject" id="subject" />

        <label for="message">Message</label>
        <textarea name="message" id="message" rows="6" placeholder="Type your message here." required></textarea>

        <button type="submit" className="btn">Submit</button>
      </form>
    </div >
  )
}

export default Form